import styled from "styled-components";
import {
  COLORS,
  responsive,
} from "../../../../../../../../styles/constants.style";

export const ViewProgramFeeWrapper = styled.div`
  .content {
    padding: 24px 16px;

    ${responsive.MOBILE`
      padding: 24px 8px;
    `}
  }

  .config-header {
    margin-top: 24px;
  }

  .dashed-line {
    margin: 24px 0px;
    border: 1px dashed ${COLORS.primary_light_blue4};
  }

  .form-field-normal {
    &:nth-child(-n + 3) {
      margin-top: 24px;
    }
    &:nth-child(n + 4) {
      margin-top: 40px;
    }
    &.inner {
      margin-top: 24px;
    }

    &.no-margin {
      margin-top: 0px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 40px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 40px;
      }
      &:nth-child(n+2) {
        margin-top: 40px;
      }
    `}
  }

  .special-instructions-grid {
    padding-top: 16px;
  }
`;
